import { useIntl, defineMessages } from 'react-intl'

import { SelectTags } from 'components/v2/SelectTags'
import { useCompanyLinesAutocompleteQuery } from 'features/Lines/hooks'

const messages = defineMessages({
  emptyMessage: {
    id: 'companyLines.multiselect.emptyMessage',
    defaultMessage: 'No company lines found'
  }
})

export const CompanyLinesMultiSelect = ({ onChange, companyId, ...props }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const { companyLines } = useCompanyLinesAutocompleteQuery({ companyId, skip: !companyId })

  const getFilteredCompanyLines = (): TSFixMe => {
    if (companyLines) {
      const selectedCompanyLinesIds = props.values.map(({ id }: TSFixMe): TSFixMe => id)

      return companyLines.filter((companyLine): TSFixMe => {
        return selectedCompanyLinesIds.indexOf(companyLine.id) === -1
      })
    }

    return []
  }

  const handleChange = (values: TSFixMe): TSFixMe => {
    onChange(values)
  }

  return (
    <SelectTags
      items={getFilteredCompanyLines()}
      getTagLabel={({ name }): TSFixMe => name}
      emptyMessage={intl.formatMessage(messages.emptyMessage)}
      onChange={handleChange}
      {...props}
    />
  )
}
